import { render } from "./PasswordSetupForm.vue?vue&type=template&id=bf692166"
import script from "./PasswordSetupForm.vue?vue&type=script&lang=js"
export * from "./PasswordSetupForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__